exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vm--overlay[data-v-36e50ada]{background:#000;opacity:.7}.overlay-enter[data-v-36e50ada],.overlay-leave-to[data-v-36e50ada]{opacity:0}.overlay-enter-active[data-v-36e50ada],.overlay-leave-active[data-v-36e50ada]{transition:all .3s}", ""]);

// exports
